// extracted by mini-css-extract-plugin
module.exports = {"hiddenButton":"hidden-button_hiddenButton__jNp1h"};